export const imageContainerStyles = {
  top: { xs: "-100%", xl: "-160%" },
  right: { xs: "-28px", xl: "-140px" },
  zIndex: -1,
  maxWidth: "100%",
  transform: { xl: "translateX(30px)" },
  width: { lg: 650, xl: 960 },
};
